import { Component, Input, OnChanges, OnInit } from '@angular/core';

import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
  styleUrls: ['./report-list.component.css']
})
export class ReportListComponent implements OnInit,OnChanges {

  @Input() program: any;
  programData: any;
  reportLength: any;
  dateFormat = 'd MMM y';
  constructor(private dashboardService: DashboardService) { }

  ngOnInit(): void {
    
    this.getUserData();
  }
  
  ngOnChanges(){
    console.log("program onChanges : ", this.program)
  }

  getUserData(){
    this.dashboardService.self().subscribe(
      (res: any) => {
        console.log("self report-list: ", res)
        this.getProgramActivation(res.userGroup);
      }, (error) => {
        console.log(error);
      }
    );
  }

  getProgramActivation(userGroup) {
    this.dashboardService.getProgramActivation().subscribe(
      (res: any) => {
        this.programData = JSON.parse(JSON.stringify(res['data']));
        localStorage.setItem('ActivationData',JSON.stringify(this.programData[0]));
        this.getReportItems(this.programData[0].program.activation.activities, userGroup)
      }, (error) => {
        console.log(error);
      }
    );
  }
  subTaskMenu=[];
  showReportList = false;
  getReportItems(res, userGroup){
    console.log("userGroup : ", userGroup);
    this.subTaskMenu=[]
    res.forEach(element => {
      if(element.isPublish){
        const batches= element.batches;
        if(element.type=="REPORTS"){
          batches.forEach(batchEl => {
            batchEl.title = element.title;
            batchEl.description = element.description;
            batchEl.image = element.image;
            if(batchEl.userGroup.includes(userGroup) || batchEl.userGroup.length==0)
                this.subTaskMenu.push(batchEl);
          });
          
        }
      }
      
    });
    console.log("report menu : ", this.subTaskMenu)
    this.showReportList=true;
  }

  openReport(url){
    let pattern= /https:/i;
    if(url.match(pattern)){
      window.open(url, "_blank");
    }else{
      url= 'https://'+ url;
      window.open(url, "_blank");
    }
  }

}
